import { useEffect, useId, useRef } from "react";
import { ErrorNotice } from "../components/AdminFeedback";
import { useLocale } from "../i18n";

export function ScopedRoleDeleteDialog({ name, scopeName, busy, uncertain, error, onConfirm, onClose }: {
  name: string; scopeName: string; busy: boolean; uncertain: boolean; error: unknown;
  onConfirm: () => void; onClose: () => void;
}) {
  const { w } = useLocale(); const id = useId(); const ref = useRef<HTMLDialogElement>(null);
  useEffect(() => { const dialog = ref.current; dialog?.showModal(); return () => dialog?.close(); }, []);
  const locked = busy || uncertain;
  return <dialog ref={ref} className="action-dialog" aria-labelledby={id}
    onCancel={e => { e.preventDefault(); if (!locked) onClose(); }}
    onClick={e => { if (e.target === ref.current && !locked) onClose(); }}>
    <h2 id={id}>{w("حذف الدور", "Delete role")} · {name}</h2>
    <p>{w("نطاق الدور", "Role scope")}: <strong>{scopeName}</strong></p>
    <p>{w("سيُحذف تعريف هذا الدور إذا لم يكن مرتبطاً بإعدادات تصويت أو تعيينات أو دعوات أو طلبات ترشح. لا يحذف هذا الإجراء أشخاصاً أو نتائج.", "This definition will be deleted only if it has no voting configuration, assignments, invitations or nominations. This action does not delete people or results.")}</p>
    <ErrorNotice error={error} />
    {uncertain && <p role="status">{w("لم تُحسم نتيجة الطلب. أعد المحاولة بالطلب نفسه لتأكيد النتيجة.", "The outcome is uncertain. Retry the same request to confirm its result.")}</p>}
    <div className="dialog-actions">
      <button type="button" className="secondary" autoFocus disabled={locked} onClick={onClose}>{w("إلغاء", "Cancel")}</button>
      <button type="button" className="danger" disabled={busy} onClick={onConfirm}>
        {busy ? w("جارٍ الحذف…", "Deleting…") : uncertain ? w("إعادة المحاولة", "Retry") : w("تأكيد حذف الدور", "Confirm role deletion")}
      </button>
    </div>
  </dialog>;
}
